import * as React from 'react';
import { useEffect } from 'react';

import { AnalyticsStore, ContextStore } from 'bernie-core';
import { ErrorBoundary, Viewport, ViewLarge } from 'bernie-view';
import { UitkViewTemplateSearchResults } from 'uitk-react-view';
import { Footer, Header } from '@gc/global-components';

import { AdvertisingStore, ClientMetadataStore, ListingsStore, SortFilterStore, ErrorStore } from 'stores';
import { useStores } from 'utility/hooks';

import { GlassboxWrapper } from 'components/glassbox/glassbox-wrapper';
import { Dialogs } from 'components/search/dialogs';
import { Filter } from 'components/search/sort-filter';
import { MesoDisplayAdsGroup, MesoInit, IntentMedia } from 'components/meso';
import { FlightsError } from 'components/shared/error-messages';
import { SearchHeading } from 'components/search/search-heading';
import { SearchForm } from 'components/search/wizard';
import { SearchResults } from 'components/search/search-results';
import { ListingLoadingBar } from 'components/search/listings';
import { setPageTitle } from 'utility/page-tab-title';
import { preConnectOrigins } from 'utility';

interface FlightsSearchProps {
  context: ContextStore;
  advertisingStore: AdvertisingStore;
  listingsStore: ListingsStore;
  sortFilterStore: SortFilterStore;
  errorStore: ErrorStore;
  clientMetadataStore: ClientMetadataStore;
  analytics: AnalyticsStore;
}

const FlightsSearch: React.FunctionComponent<FlightsSearchProps> = () => {
  const {
    context,
    advertisingStore,
    listingsStore,
    sortFilterStore,
    errorStore,
    clientMetadataStore,
    analytics
  } = useStores();
  const pageName =
    clientMetadataStore && clientMetadataStore.pageNameAnalytics && clientMetadataStore.pageNameAnalytics.rfrr;

  advertisingStore.setPageName(pageName);

  useEffect(() => {
    setPageTitle(clientMetadataStore, analytics);
  }, [analytics, clientMetadataStore, clientMetadataStore.pageName]);

  useEffect(() => {
    preConnectOrigins();
  }, []);

  return (
    <ErrorBoundary label="flights.search.page" fallback={<FlightsError />}>
      {errorStore && errorStore.shouldRenderNoApiResponseError ? (
        <FlightsError />
      ) : (
        <>
          <input
            aria-hidden={true}
            value={pageName}
            className="is-visually-hidden"
            data-test-id="page-id"
            id="pageId"
            disabled={true}
            readOnly={true}
          />

          {listingsStore && !listingsStore.loading && (
            <>
              <MesoInit />
              <IntentMedia />
              <GlassboxWrapper />
            </>
          )}
          <Header />

          <UitkViewTemplateSearchResults
            changeSearch={<SearchForm />}
            loadingBar={listingsStore && listingsStore.progressBarDetails && <ListingLoadingBar />}
            searchHeading={<SearchHeading />}
            searchFilters={
              sortFilterStore && (
                <Viewport>
                  <ViewLarge>
                    <Filter keySuffix="onACol" />
                  </ViewLarge>
                </Viewport>
              )
            }
            searchResults={<SearchResults />}
            sideRailAd={
              listingsStore &&
              !listingsStore.loading && <MesoDisplayAdsGroup type={MesoDisplayAdsGroup.adType.MESO_SIDE_RAILS_ADS} />
            }
          />

          {!listingsStore.loading && (
            <>
              <Footer context={context} />
              <Dialogs dialogType="FlightsDialogStaleSession" />
            </>
          )}
        </>
      )}
    </ErrorBoundary>
  );
};

export default FlightsSearch;
